<template>
    <div v-show="display" class="tw-flex-none tw-w-full" style="margin-right: 25px">
        <template v-if="hasDisplayed">
            <slot></slot>
        </template>
    </div>
</template>

<script>
export default {
    name: "BaseTab",

    props: {
        name: {
            type: String,
            required: true
        },
        trigger: String,
        label: String
    },

    data() {
        return {
            display: false,
            triggerComponent: null,
            hasDisplayed: false
        }
    },

    methods: {
        toggle(value) {
            this.display = value;

            if(value) {
                // When the tab is displayed for the first time, keep track of that
                // This prevents tabs other than the initial tab from loading right away, cutting down on unnecessary api requests and such
                this.hasDisplayed = true;
            }

        }
    }
}
</script>

<style>

</style>